import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "cart-empty"
};
var _hoisted_2 = ["src"];
import { useRouter } from 'vue-router';
import { useLess } from '@/models/hooks';
import imageLink from '@/configs/imageLink';
export default {
  __name: 'CartEmpty',
  props: {
    emptyTextPartOne: {
      type: String,
      required: true,
      default: ''
    },
    emptyTextPartTwo: {
      type: String,
      required: true,
      default: ''
    },
    showButton: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    var props = __props;
    var CART_EMPTY = imageLink.CART_EMPTY;
    useLess('views/cart/components/CartEmpty.less');
    // eslint-disable-next-line no-unused-vars

    var router = useRouter();
    var goToShopping = () => {
      router.push({
        name: 'todayDeal'
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
        src: _unref(CART_EMPTY),
        alt: ""
      }, null, 8, _hoisted_2), _createElementVNode("p", null, _toDisplayString(__props.emptyTextPartOne), 1), _createElementVNode("p", null, _toDisplayString(__props.emptyTextPartTwo), 1), __props.showButton ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "button -primary m-t-32",
        onClick: goToShopping
      }, _toDisplayString(_ctx.$t('modules.cart.GO_CHECK_IT_OUT')), 1)) : _createCommentVNode("", true)]);
    };
  }
};